<template>
    <div id="app">
        <v-app id="inspire">
            <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="250">
                <v-container>
                    <v-layout>
                        <h4 class="subheading font-weight-medium">INVITE BRANCH USER</h4>
                        <v-spacer></v-spacer>
                        <h4 class="subheading font-weight-medium">{{user.displayName}}</h4>
                    </v-layout>
                </v-container>
            </v-parallax>

            <v-layout row justify-center>
                <v-dialog :value="true" persistent hide-overlay max-width="600px">
                    <v-card>
                        <v-card-text>
                            <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs8>
                                    <v-text-field class="pr-0" outline label="Email*" v-model='email' prepend-inner-icon="email" required></v-text-field>
                                </v-flex>
                                <v-flex xs4>
                                    <!-- <v-text-field class="pr-0" outline label="Domain" required v-model="domain" readonly=""></v-text-field> -->
                                    <v-select outline label="Domain*" v-model='domain' :items="domains" required></v-select>
                                </v-flex>

                                <v-flex xs12>
                                    <v-autocomplete outline v-model="branch"  label="Branch*" :items="activeBranches" persistent-hint prepend-inner-icon="domain" hide-no-data clearable leave-absolute>
                                        <template v-slot:append-outer>
                                            <v-slide-x-reverse-transition mode="out-in">
                                            </v-slide-x-reverse-transition>
                                        </template>
                                    </v-autocomplete>
                                </v-flex>

                                <v-flex xs3>
                                    <v-text-field class="pr-0" outline label="Country Code" required :value="'+63'" readonly></v-text-field>
                                </v-flex>

                                <v-flex xs9>
                                    <v-text-field class="pl-0" outline v-model="mobileNumber" :rules="mobileChecker" label="Mobile Number*" maxlength="10" prepend-inner-icon="phone" type="text" required hint=" ex.9123456789"></v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-select outline label="Role/Position*" v-model='role' :items="roles" prepend-inner-icon="accessibility" required></v-select>
                                </v-flex>
                            </v-layout>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue-grey" dark @click='$router.push("/users-management")'>CANCEL</v-btn>
                                <v-btn color="red accent-4" dark @click="sendInvites()">INVITE BRANCH USER</v-btn>
                            </v-card-actions>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-layout>

            <v-dialog v-model="showProgress" persistent width="300">
                <v-card  color="primary">
                    <v-card-text class="subheading white--text">{{progressMessage}}
                        <v-layout row justify-center>
                        <v-progress-linear :indeterminate="true" v-if="showProgress"
                            :size="70"
                            :width="5"
                            color="white"
                        ></v-progress-linear>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-snackbar v-model="showSnackBar" bottom right :color="snackbarColor" :timeout=3000>
                    {{snackbarMessage}}
                <v-btn dark small flat @click="showSnackBar = false">Close</v-btn>
            </v-snackbar>
        </v-app>
    </div>
</template>

<script>
import firebase from "firebase"
import firebaseui from "firebaseui"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { config } from "../firebaseConfig"
import router from '../router'
import { db } from '../main.js'
import { mapGetters, mapActions } from "vuex"
import store from '../stores'
import moment from 'moment'
import _ from 'lodash'
export default {
    data() {
        return {
            email: "",
            branch: "",
            role: "",
            branches: [],
            snackbarMessage: "",
            progressMessage: "",
            showProgress: false,
            showSnackBar: false,
            activeBranches: [],
            // domain: "@scinnova.com.ph",
            domain: "",
            snackbarColor: "primary",
            mobileNumber: "",
            mobileChecker: [v => v.length == 10|| 'Mobile number must be valid'],
            roles: [],
            roleItems: [],
            branchId: "",
            domains: []
        }
    },

    mounted() {
        this.fetchBranches()
        this.fetchRoles()
        this.fetchDomains()
    },

    methods: {
        async fetchRoles() {
            let self = this
            self.roles = []

            await db.collection("Settings"+self.$stage).doc("Roles")
            .collection("Items").get().then(function(querySnapshots) {
                querySnapshots.forEach(function(doc){
                    self.roleItems.push(doc.data())
                })
            }).then(function() {
                self.roleItems.forEach(function(res) {
                    self.roles.push(res.role)
                })
            }).catch(function(error){
                console.log(error)
            })
        },

        async fetchDomains() {
            let self = this
            self.domains = []

            await db.collection("Settings"+self.$stage).doc("Domain")
            .collection("Items").get().then(function(querySnapshots) {
                querySnapshots.forEach(function(doc){
                    self.domains.push(doc.data().domain)
                })
            }).catch(function(error){
                console.log(error)
            })
        },
        
        sendInvites() {
            let self = this
            if(self.email  != "" && self.branch != "" && self.role != "" && self.mobileNumber != "") {
                if (self.email.includes("@scinnova.com.ph") || self.email.includes("@")) {
                    self.snackbarMessage = "do not input domain"
                    self.snackbarColor = "error"
                    self.showSnackBar = true
                } else if (self.mobileNumber.length !== 10) {
                    self.snackbarMessage = "Please input valid mobile number"
                    self.snackbarColor = "error"
                    self.showSnackBar = true
                } else {
                    self.progressMessage="Sending Invite..."
                    self.showProgress=true
                    self.notification()
                }
            } else {
                self.snackbarMessage = "Please fill up all details"
                self.snackbarColor = "error"
                self.showSnackBar = true
            }
        },

        notification(){
            let self = this
            let message = "Hello!" + "\n\n Admin".bold() + " set up your account in Service Scheduler. \n\n Service Scheduler is a scheduling tool that helps the customers set up service appointment accross different branches at their most convenient day and time. \n\n " + "Your Login Email: ".bold() + `${self.email}${self.domain}` + "\n\nPlese click on the button below or " +"click this link".link(self.$branchUrl + "/login")  + " to confirm your email address and access the site.\n\n " +  '<form action="branch.aftersales.scinnova.com.ph/login"><button type="submit"><b>Confirm My Email</b></button></form>'+"\n\n Sincerely,\nService Scheduler Team"

            let emailMessage = message.replace(/(\r\n|\n|\r)/gm, "<br>")
            let load = {
                "receiver" : `${self.email}${self.domain}`,
                "subject" : "Admin has set up your account on Service Scheduler",
                "html" : emailMessage
            }

            self.$axios.post(self.$mailerUrl, load).then(response => {
            db.collection("branchUsers"+self.$stage).doc(`${self.email}${self.domain}`).set({
                    email: `${self.email}${self.domain}`,
                    branch: self.branch.split('_')[1].trim(),
                    branchCode: self.branch.split('_')[0].trim(),
                    branchId: self.branchId,
                    mobileNumber: self.mobileNumber,
                    role: self.role,
                    status: "pending",
                    creationDate: moment().format('MMMM Do YYYY, h:mm:ss a'),
                    activationDate: "",
                    modifiedDate: "",
                    inactiveDate: "",
                }).then(function() {
                    self.showProgress=false
                    self.snackbarMessage = "Invitation Sent" 
                    self.snackbarColor = "success"
                    self.showSnackBar= true
                    setTimeout(() => {
                        self.goToPage("users-management")
                    }, 1000)
                }).catch(function(error) {
                    self.snackbarMessage = "Error saving in database" 
                    self.snackbarColor = "error"
                    self.showSnackBar= true
                    console.error(error)
                })
            }).catch(function(error) {
                self.snackbarMessage = "Invitation Rejected! Invalid email." 
                self.snackbarColor = "error"
                self.showSnackBar= true
                console.error(error)
            })
        },

        async fetchBranches() {
            let self = this 
            self.activeBranches = []
            self.branches = []
            await db.collection("Branches"+self.$stage)
                .get().then(function(querySnapshots) {
                    querySnapshots.forEach(function(doc) {
                        if (doc.data().status == true) {
                            self.activeBranches.push(`${doc.data().branchCode}_${doc.data().businessUnit}`)
                            self.branches.push(doc.data())
                        }
                    })
                }).then(function(){
                    if (self.activeBranches.length === 0) {
                        self.snackbarColor = "error"
                        self.snackbarMessage = "Please setup Branch"
                        self.showSnackBar = true
                    } else {
                        self.activeBranches = _.sortBy(self.activeBranches, o => o.cluster)
                    }
                }).catch(function(error) {
                    console.error("Error fetching document: ", error)
                    self.snackbarMessage = "Error fetching data" 
                    self.snackbarColor = "error"
                    self.showSnackBar= true
                })
        },

        goToPage(page) {
            this.$router.push("/"+page)
        },
    },

    watch: {
        branch(val){
            let self = this
            self.branchId = ""
            _.find(self.branches, function(o) {
                if (o.branchCode == val.split('_')[0].trim()) {
                    self.branchId = o.id
                }
            })
        }
    },

    computed : {
        ...mapGetters(["user"]),
    },
}
</script>

<style scoped>

</style>